import { BaseRouteService } from 'core/services';

class DoctorRouteService extends BaseRouteService {
    constructor() {
        super('doctors');
    }

    find(filter) {
        return super.find(this.base + '/{?searchQuery,page,rpp,sort,embed,fields}', filter);
    }

    get(id) {
        return super.get(this.base + '/{id}', id);
    }
}

export default DoctorRouteService;
